import { render, staticRenderFns } from "./MegaNav.vue?vue&type=template&id=53ba4906&scoped=true&"
import script from "./MegaNav.vue?vue&type=script&lang=js&"
export * from "./MegaNav.vue?vue&type=script&lang=js&"
import style0 from "./MegaNav.vue?vue&type=style&index=0&id=53ba4906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba4906",
  null
  
)

export default component.exports